export const envVars = {
  IS_PRODUCTION: import.meta.env.PROD,
  BASE_URL: import.meta.env.VITE_API_BASE_URL,
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
  GOOGLE_CALLBACK_URL: import.meta.env.VITE_GOOGLE_CALLBACK_URL,
  SOCKET_URL: import.meta.env.VITE_API_SOCKET_URL,
}
